/* src/app/modules/patternmatch/components/pm-chart/pm-chart.component.scss */
:host {
  --border-color_: var(--border-color, var(--highlight-20));
  --border-color-solid_: var(--border-color-solid, rgb(145, 145, 145));
  --border-thickness_: var(--border-thickness, 1px);
  --label-color: var(--text-secondary);
  --hover-raise: 0px;
  --bar-color-01_: var(--bar-color-01, var(--support-1-tint));
  --vertical-items-color: var(-text-secondary);
  --rad: 0.3rem;
  display: flex;
  flex-direction: column;
  height: 250px;
  box-sizing: border-box;
  gap: 1.5rem;
  font: var(--body-1);
}
.bins {
  position: relative;
  margin-left: 1rem;
  margin-right: 1rem;
  display: flex;
  flex-direction: row;
  flex: 1;
  transition: var(--transition-time) all ease-in-out;
}
.bin {
  flex: 1 0;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  overflow-x: hidden;
  transition: var(--transition-time) all ease-in-out;
}
.label {
  display: flex;
  height: 2rem;
  padding: 0.25rem;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  color: var(--label-color);
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
}
.label::after {
  content: "";
  background-color: var(--border-color_);
  position: absolute;
  height: 4px;
  width: var(--border-thickness_);
  top: 0px;
  left: 50%;
}
[screen-phone] :host-context .label {
  font-size: 80%;
}
[screen-phone] :host-context .item {
  width: 60%;
}
.item {
  height: calc(var(--count) * (100% - 2rem) / var(--max-count));
  background: var(--bar-color-01_);
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  z-index: 1;
  transition: var(--transition-time) all ease-in-out;
  box-shadow: var(--shadow-flat);
  margin-left: 0rem;
  margin-right: 0rem;
  margin-top: 0rem;
  margin-bottom: 0rem;
  cursor: pointer;
}
.item.disabled {
  filter: grayscale(100%);
  opacity: 0.5;
}
.item:first-child {
  border-radius: var(--rad) var(--rad) 0rem 0rem;
}
[item-hover]:hover,
[bin-hover]:hover > * {
  filter: brightness(80%);
  margin-left: calc(-1 * var(--hover-raise));
  margin-right: calc(1 * var(--hover-raise));
  margin-top: calc(-1 * var(--hover-raise));
  margin-bottom: calc(1 * var(--hover-raise));
}
.line {
  position: absolute;
  bottom: calc(2rem - var(--border-thickness_) + var(--index) * (100% - 2rem) / (var(--max-count)));
  border-top: var(--border-color_) var(--border-thickness_) dashed;
  right: 1rem;
  left: 0px;
}
.line:first-of-type {
  border-top: var(--border-color-solid_) 2px solid;
  right: 0rem;
  z-index: 2;
}
.line:first-of-type span {
  display: none;
}
.line span {
  position: absolute;
  width: 2rem;
  text-align: right;
  right: -1rem;
  transform: translate(40%, -50%);
  color: var(--vertical-items-color);
}
.labels {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-left: 1rem;
}
.labels .item-label::before {
  content: "";
  display: inline-block;
  height: 0.8rem;
  width: 0.8rem;
  margin-right: 0.2rem;
  background: var(--bar-color-01_);
}
.vertical-units {
  margin-left: auto;
  color: var(--vertical-items-color);
}
/*# sourceMappingURL=pm-chart.component.css.map */
